export default __webpack_public_path__ + "static/media/jcb.98258935.svg";